import { getQuoteSuppliers } from '../../../quotes/quote-service';
import { v6Config, v6SupportsVersion, v6VersionMap } from '../../../v6config/v6config';

export async function setSupplierReferenceOverride(akey: string) {
  //DO NOT CALL THIS UNLESS YOU KNOW THE V6 BOOT LOADER IS RUNNING
  if (v6SupportsVersion(v6VersionMap.hasQuoteOwnerLevelSettings)) v6Config().setSupplierReferenceOverrideKey?.(akey);
  await getQuoteSuppliers(true);
}
